<a
  *transloco="let t; read: 'social-share-buttons'"
  id="trkEmailShareButton"
  class="btn-share btn-share-email"
  href="mailto:?body={{ text }} {{ url }}"
  [attr.aria-label]="t('email_share')">
  <accredible-icon [icon]="'email'"> </accredible-icon>
</a>
